export const SOCKET_URLS = {
  dev: 'https://notification-dev.gohaptik.com',
  staging: 'https://notification-staging.gohaptik.com',
  qa: 'https://notification-qa.gohaptik.com',
  production: 'https://notifications.hapanaforce.com',
}

export const SOCKET_EVENTS = {
  connect: 'connect',
  disconnect: 'disconnect',
  connectError: 'connect_error',
  connectTimeout: 'connect_timeout',
  newCheckIn: 'NewCheckIn',
  checkInResponse: 'CheckInResponse',
  growInitialLoad: 'GrowInitialLoadResponse',
}
